"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardGradeValueMap = exports.LeaderboardGrade = void 0;
var LeaderboardGrade;
(function (LeaderboardGrade) {
    LeaderboardGrade["TOP"] = "TOP";
    LeaderboardGrade["TOP_10"] = "TOP_10";
    LeaderboardGrade["TOP_100"] = "TOP_100";
    LeaderboardGrade["NONE"] = "NONE";
})(LeaderboardGrade = exports.LeaderboardGrade || (exports.LeaderboardGrade = {}));
exports.LeaderboardGradeValueMap = [
    [1, LeaderboardGrade.TOP],
    [10, LeaderboardGrade.TOP_10],
    [100, LeaderboardGrade.TOP_100],
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGVhZGVyYm9hcmRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3R5cGVzL2xlYWRlcmJvYXJkcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFpQkEsSUFBWSxnQkFLWDtBQUxELFdBQVksZ0JBQWdCO0lBQzFCLCtCQUFXLENBQUE7SUFDWCxxQ0FBaUIsQ0FBQTtJQUNqQix1Q0FBbUIsQ0FBQTtJQUNuQixpQ0FBYSxDQUFBO0FBQ2YsQ0FBQyxFQUxXLGdCQUFnQixHQUFoQix3QkFBZ0IsS0FBaEIsd0JBQWdCLFFBSzNCO0FBRVksUUFBQSx3QkFBd0IsR0FBc0M7SUFDekUsQ0FBQyxDQUFDLEVBQUUsZ0JBQWdCLENBQUMsR0FBRyxDQUFDO0lBQ3pCLENBQUMsRUFBRSxFQUFFLGdCQUFnQixDQUFDLE1BQU0sQ0FBQztJQUM3QixDQUFDLEdBQUcsRUFBRSxnQkFBZ0IsQ0FBQyxPQUFPLENBQUM7Q0FDaEMsQ0FBQyJ9